import styled from "@emotion/styled";
import { flexBetween } from "../config/commonCSS";

export const FlexBetweenContainer = styled.div<{
  direction?: "row" | "column";
  justifyContent?: "center" | "space-between" | "space-around" | "end";
  stretch?: boolean;
  widthExpand?: boolean;
  wrap?: boolean;
}>`
  ${flexBetween};
  flex-direction: ${props => props.direction};
  align-self: ${props => (props.stretch ? "stretch" : "auto")};
  width: ${props => (props.widthExpand ? "100%" : "auto")};
  flex-wrap: ${props => (props.wrap ? "flex-wrap" : "auto")};
  justify-content: ${props => props.justifyContent};
`;
